module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('section', [_vm._m(0), _c('h1', [_vm._v(_vm._s(_vm.$route.meta.title))])]), _c('div', {
    staticClass: "mb-5"
  }), _c('section'), _c('div', {
    staticClass: "mb-10"
  }), _vm._m(1), _c('div', {
    staticClass: "mb-40"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-decoration"
  }, [_c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("主辦單位")]), _c('div', {
    staticClass: "logo-wrap"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/thanks/logo-4gamers.png")
    }
  }), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/thanks/logo-infamous.png")
    }
  })]), _c('div', {
    staticClass: "section-title"
  }, [_vm._v("合作夥伴")]), _c('div', {
    staticClass: "logo-wrap"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/thanks/logo-nvidia.png")
    }
  }), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/thanks/logo-cht.png")
    }
  })]), _c('div', {
    staticClass: "section-title"
  }, [_vm._v("合辦單位")]), _c('div', {
    staticClass: "logo-wrap"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/thanks/logo-taipeiDED.png")
    }
  }), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/thanks/logo-dcipo.png")
    }
  }), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/thanks/logo-ifin.png")
    }
  })]), _c('div', {
    staticClass: "section-title"
  }, [_vm._v("WirForce 推薦處理器")]), _c('div', {
    staticClass: "logo-wrap"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/thanks/logo-intel.png")
    }
  })]), _c('div', {
    staticClass: "section-title"
  }, [_vm._v("參與單位")]), _c('div', {
    staticClass: "logo-wrap"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/thanks/logo-gigabyte.png")
    }
  }), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/thanks/logo-asus.png")
    }
  }), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/thanks/logo-twitch.png")
    }
  }), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/thanks/logo-cygames.png")
    }
  }), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/thanks/logo-msi.png")
    }
  }), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/thanks/logo-teamgroup.png")
    }
  }), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/thanks/logo-agon.png")
    }
  }), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/thanks/logo-hyperx.png")
    }
  }), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/thanks/logo-double.png")
    }
  }), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/thanks/logo-omen.png")
    }
  }), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/thanks/logo-preoator.png")
    }
  }), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/thanks/logo-patriot.png")
    }
  }), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/thanks/logo-xpg.png")
    }
  }), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/thanks/logo-ubisoft.png")
    }
  }), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/thanks/logo-magic.png")
    }
  }), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/thanks/logo-plantronics.png")
    }
  }), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/thanks/logo-tca.png")
    }
  })]), _c('div', {
    staticClass: "section-title"
  }, [_vm._v("大會推薦電競椅品牌")]), _c('div', {
    staticClass: "logo-wrap"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/thanks/logo-sharkoon.png")
    }
  })]), _c('div', {
    staticClass: "section-title"
  }, [_vm._v("協力夥伴")]), _c('div', {
    staticClass: "logo-wrap"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/thanks/logo-asc.png")
    }
  }), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/thanks/logo-met.png")
    }
  })]), _c('div', {
    staticClass: "section-title"
  }, [_vm._v("媒體合作單位")]), _c('div', {
    staticClass: "logo-wrap"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/thanks/logo-yahoo.png")
    }
  }), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/thanks/logo-uacg.png")
    }
  }), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/thanks/logo-piko.png")
    }
  }), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/thanks/logo-xfastest.png")
    }
  }), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/thanks/logo-aottergirl.png")
    }
  }), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/thanks/logo-pnn.png")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c897f65"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/thanks.vue
// module id = 576
// module chunks = 1